module.exports = "<span *ngFor=\"let id of this.ids; index as i\"><div><p *ngIf=\"id==='total'; else buttons\" id=\"{{id}}\">{{id}}: {{this.total}}</p><ng-template #buttons><a id=\"{{ id }}\">{{ id }} View</a></ng-template></div></span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-search-view-btns/app-search-view-btns.component.pug
// module id = 1163
// module chunks = 1